// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud Costs API
 * API to get cloud cost information about Aura components and dev environments. Is used by the Aura Portal.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApitypesTotalPerDay
 */
export interface ApitypesTotalPerDay {
  /**
   *
   * @type {string}
   * @memberof ApitypesTotalPerDay
   */
  dateIncurred?: string;
  /**
   *
   * @type {number}
   * @memberof ApitypesTotalPerDay
   */
  total?: number;
}

/**
 * Check if a given object implements the ApitypesTotalPerDay interface.
 */
export function instanceOfApitypesTotalPerDay(
  value: object,
): value is ApitypesTotalPerDay {
  return true;
}

export function ApitypesTotalPerDayFromJSON(json: any): ApitypesTotalPerDay {
  return ApitypesTotalPerDayFromJSONTyped(json, false);
}

export function ApitypesTotalPerDayFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApitypesTotalPerDay {
  if (json == null) {
    return json;
  }
  return {
    dateIncurred:
      json['dateIncurred'] == null ? undefined : json['dateIncurred'],
    total: json['total'] == null ? undefined : json['total'],
  };
}

export function ApitypesTotalPerDayToJSON(json: any): ApitypesTotalPerDay {
  return ApitypesTotalPerDayToJSONTyped(json, false);
}

export function ApitypesTotalPerDayToJSONTyped(
  value?: ApitypesTotalPerDay | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    dateIncurred: value['dateIncurred'],
    total: value['total'],
  };
}
